import { Button, ButtonStyle, CardContent, CardHeader, IPromotionResponse } from '@one-tree/library'
import React, { ReactElement, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { get } from '../../helpers/APIHelper'
import { Resource } from '../../types/API'
import { RoutePath } from '../../types/Routes'
import { convertPromoResponseToPromotion, Promotions } from './promotion/PromotionHelper'
import PromotionTable from './promotion/PromotionTable'

export default function ManagePromotions(): ReactElement {
  const history = useHistory()
  const location = useLocation()

  const [promotions, setPromotions] = useState<Promotions>([])
  const [loading, setLoading] = useState(false)

  const fetchPromotions = async (): Promise<void> => {
    setLoading(true)
    const res = await get<IPromotionResponse[]>({ resource: Resource.Promotions })
    if (Array.isArray(res)) {
      setPromotions(res.map(convertPromoResponseToPromotion))
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchPromotions()
  }, [location.pathname])

  return (
    <>
      <CardHeader title="Manage promotions">
        <Button
          buttonStyle={ButtonStyle.Action}
          onClick={(): void => history.push(RoutePath.CreatePromotion)}
        >
          Create new promotion
        </Button>
      </CardHeader>
      <CardContent>
        <p>
          Promotions are applied to Gift Vouchers to provide discounts on
          prices.
        </p>
        <br />
        <PromotionTable promotions={promotions} loading={loading} />
      </CardContent>
    </>
  )
}
